import { useSelector } from "react-redux";
import { USER_ROLE_CODE_MANAGER } from "cityads-v3/reducers/auth";
import { RootState } from "cityads-v3/types/reducer";

export enum UserRoleCode {
  Manager = 'M',
  Advertiser = 'A',
  Webmaster = 'W',
  AdvMadnet = 'N'
}

export const authRegexp = /(?:\/(auth|register|lost)(\/[^/]*)?)+$/;

export function useIsManager(): boolean {
  const user = useSelector((state: RootState) => state.auth.user)
  if (user?.user_role_code === USER_ROLE_CODE_MANAGER) {
    return true
  }

  return false
}
